import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function ImageModal({ isOpen, image, onClose }) {
  if (!image) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4 md:p-8"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="relative max-w-5xl w-full h-full flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={onClose}
              className="absolute -top-12 right-0 md:top-4 md:-right-12 p-2 text-white hover:text-gray-300 transition-colors"
            >
              <SafeIcon icon={FiX} className="text-3xl" />
            </button>

            <div className="relative group w-full h-full flex flex-col items-center justify-center">
              <img
                src={image.image_url}
                alt={image.title}
                className="max-h-full max-w-full object-contain rounded-lg shadow-2xl"
                onContextMenu={(e) => e.preventDefault()}
                draggable="false"
                style={{ WebkitUserDrag: 'none', userSelect: 'none' }}
              />
              
              <div className="mt-4 text-center md:absolute md:bottom-[-60px] md:left-0 md:right-0 pointer-events-none">
                <h3 className="text-white font-bold text-lg">{image.title || 'Portfolio Graphic'}</h3>
                {image.categories_1715000000?.name && (
                  <p className="text-gray-400 text-sm">{image.categories_1715000000.name}</p>
                )}
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}